(function(){

class KeySet {
	constructor(keyStr){
		let keys = keyStr.split('+');

		let argSet = {
			control: false,
			shift: false,
			alt: false,
			super: false,
			key: null
		};

		keys.forEach(key => {
			key = key.toLowerCase();
			switch(key){
				case 'ctl':
				case 'ctrl':
				case 'control':
					argSet.control = true;
					break;
				case 'sh':
				case 'shft':
				case 'shift':
					argSet.shift = true;
					break;
				case 'alt':
				case 'opt':
				case 'option':
					argSet.alt = true;
					break;
				case 'meta':
				case 'super':
				case 'cmd':
				case 'command':
				case 'win':
				case 'windows':
					argSet.super = true;
					break;
				default:
					argSet.key = key;
					break;
			}
		});

		Object.assign(this, argSet);
	}
	getKeyStr(){
		let set = [
			this.control ? 'ctrl' : false,
			this.shift ? 'shift' : false,
			this.alt ? 'alt' : false,
			this.super ? 'meta' : false,
			this.key ?? false
		];
		return set.filter(k => k).join('+');
	}
	static fromEvent(e){
		let set = [
			e.ctrlKey ? 'ctrl' : false,
			e.shiftKey ? 'shift' : false,
			e.altKey ? 'alt' : false,
			e.metaKey ? 'meta' : false,
			e.key ?? false
		];
		let keyStr = set.filter(k => k).join('+');
		return new KeySet(keyStr);
	}
	is(other_set){
		return this.getKeyStr() == other_set.getKeyStr();
	}
}

let keyedElements = document.querySelectorAll('[data-hotkey]');
let lookup = new Map();

keyedElements.forEach(el => {
	if( lookup.has(el.dataset.hotkey) ){
		console.warn('Could not initialize hotkey listener for:', el);
		return;
	}

	lookup.set((new KeySet(el.dataset.hotkey)).getKeyStr(), el);
});

function runKeyEvents(e){
	let evKeys = KeySet.fromEvent(e);
	if( lookup.has(evKeys.getKeyStr()) ){
		console.info(`Found [${evKeys.getKeyStr()}]`);

		let el = lookup.get(evKeys.getKeyStr());
		el.dispatchEvent(
			new Event(el.dataset.hotkeyAction, {
				target: el,
				bubbles: true,
				cancelable: true
			})
		);

		console.info(`Dispatched ${el.dataset.hotkeyAction} event on`, el);
	}
}

document.addEventListener('keydown', runKeyEvents);

})()